var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99988 0.653809C3.13425 0.653809 -0.00012207 3.78818 -0.00012207 7.65381C-0.00012207 11.5194 3.13425 14.6538 6.99988 14.6538C10.8655 14.6538 13.9999 11.5194 13.9999 7.65381C13.9999 3.78818 10.8655 0.653809 6.99988 0.653809ZM6.99988 13.4663C3.7905 13.4663 1.18738 10.8632 1.18738 7.65381C1.18738 4.44443 3.7905 1.84131 6.99988 1.84131C10.2093 1.84131 12.8124 4.44443 12.8124 7.65381C12.8124 10.8632 10.2093 13.4663 6.99988 13.4663Z",
    fill: "#8A91A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24988 4.90381C6.24988 5.10272 6.3289 5.29349 6.46955 5.43414C6.6102 5.57479 6.80097 5.65381 6.99988 5.65381C7.19879 5.65381 7.38956 5.57479 7.53021 5.43414C7.67086 5.29349 7.74988 5.10272 7.74988 4.90381C7.74988 4.7049 7.67086 4.51413 7.53021 4.37348C7.38956 4.23283 7.19879 4.15381 6.99988 4.15381C6.80097 4.15381 6.6102 4.23283 6.46955 4.37348C6.3289 4.51413 6.24988 4.7049 6.24988 4.90381ZM7.37488 6.65381H6.62488C6.55613 6.65381 6.49988 6.71006 6.49988 6.77881V11.0288C6.49988 11.0976 6.55613 11.1538 6.62488 11.1538H7.37488C7.44363 11.1538 7.49988 11.0976 7.49988 11.0288V6.77881C7.49988 6.71006 7.44363 6.65381 7.37488 6.65381Z",
    fill: "#8A91A8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.385c944c2bd2e6a4420ec12b52ef382b.svg";
export { ForwardRef as ReactComponent };